import { RootState } from '../..';
import { ContestListState } from './types';

export const selectContestList = (state: RootState): ContestListState => state.public.contestList;


